//
//
//
//
//
//

import { mapMutations, mapGetters, mapActions } from "vuex";

export default {
    name: "AppsModules",
    computed: {
        ...mapGetters("apps", ["currentApp"]),
        isAppTaskRoute() {
            return ["appUserTaskDataViews", "appUserTaskAnalytics"].includes(this.$route.name);
        }
    },
    created() {
        if (!this.currentApp.id) {
            this.getAppSettingsInfo({ id: this.$route.params.applicationId }).then(
                (data) => {
                    this.setCurrentApp(data);
                    this.setActivePage(this.$route.name);
                }
            );
        }
    },
    methods: {
        ...mapMutations("apps", ["setCurrentApp", "setActivePage"]),
        ...mapActions("apps", ["getAppSettingsInfo"])
    }
};
